<template>
  <div style="height:46px;">
    <van-nav-bar :title="title" :left-text="leftText" :right-text="rightText" :left-arrow="leftArrow" @click-left="onClickLeft" @click-right="onClickRight" fixed :z-index="1000"/>
  </div>
</template>
<script>
export default {
  name: 'NavBar',
  props: {
    title: {
      type: String,
      required: true
    },
    leftText: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    leftArrow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  methods: {
    onClickLeft() {
      this.$router.back(-1);
    },
    onClickRight() {
      this.$emit('click-right');
    }
  }
}
</script>
<style lang="less" scoped>
@import url(~style/var.less);
</style>



// WEBPACK FOOTER //
// src/components/layout/NavBar.vue